import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { convertLegacyContent, cleanState } from '@ublend-npm/aula-editor';
import { isAulaEditorState } from '@ublend-npm/aula-editor-utils';
import { resetAllFileScanStatuses } from '../../../../../../../core/actions/data/fileScan';

import {
  DONE,
  INBOX_EDIT_MESSAGE_TITLE,
} from '../../../../../../constants/texts';
import * as types from '../../../types';
import onlyWhenDefined from '../../onlyWhenDefined';
import { flow } from '../../../utils';
import EditZone from './EditZone';
import {
  TitleContainer,
  CreateIcon,
  EditZoneContainer,
} from './EditMessageModal.styled';

import Dialog, {
  DialogTitle,
  DialogContent,
  DialogActions,
} from '../../../../common/Dialog';

class EditMessageModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      editorState: cleanState,
      isSubmitting: false,
      canSave: false,
    };

    this.onReturn = this.onReturn.bind(this);
    this.onClick = this.onClick.bind(this);
    this.setEditorState = this.setEditorState.bind(this);
    this.setSubmittingState = this.setSubmittingState.bind(this);
    this.onEditorChange = this.onEditorChange.bind(this);
    this.onFilesStatusChange = this.onFilesStatusChange.bind(this);
  }

  componentDidMount() {
    const { message } = this.props;
    const parsedContent = JSON.parse(message.content);
    const initialState = isAulaEditorState(parsedContent)
      ? parsedContent
      : convertLegacyContent(parsedContent);

    this.setState((prevState) => ({
      ...prevState,
      editorState: initialState,
    }));
  }

  onClick() {
    const { editorState, canSave } = this.state;
    if (canSave) {
      this.onReturn(editorState);
    } else {
      this.setSubmittingState(true);
    }
  }

  onReturn() {
    const { save, close, handleResetScanStatus } = this.props;
    const { editorState, isSubmitting, canSave } = this.state;
    if (canSave && !isSubmitting) {
      save(JSON.stringify(editorState));
      handleResetScanStatus();
      close();
    }
  }

  onFilesStatusChange({
    isUpdating: isScanning,
    isPersistable: isSavable,
    hasError: isFailed,
  }) {
    const canSave = isSavable && !isScanning && !isFailed;
    this.setState({ canSave });
  }

  onEditorChange(editorState) {
    this.setState((prevState) => ({
      ...prevState,
      editorState,
    }));
  }

  setSubmittingState(isSubmitting) {
    this.setState((prevState) => ({
      ...prevState,
      isSubmitting,
    }));
  }

  setEditorState(editorState) {
    this.setState((prevState) => ({
      ...prevState,
      editorState,
    }));
  }

  render() {
    const { close, saving, editorConfig } = this.props;
    const { editorState, isSubmitting, canSave } = this.state;

    return (
      <Dialog
        id="edit-message-modal"
        open
        onClose={close}
        maxWidth="md"
        style={{ zIndex: 1400 }}
        disableEnforceFocus
      >
        <DialogTitle id="edit-message-modal-dialogtitle" onClose={close}>
          <TitleContainer>
            <CreateIcon />
            {INBOX_EDIT_MESSAGE_TITLE}
          </TitleContainer>
        </DialogTitle>
        <DialogContent>
          <EditZoneContainer>
            <EditZone
              editorConfig={editorConfig}
              editorState={editorState}
              onChange={this.onEditorChange}
              onFilesStatusChange={this.onFilesStatusChange}
              onReturn={this.onReturn}
              isSubmitting={isSubmitting}
              setSubmittingState={this.setSubmittingState}
            />
          </EditZoneContainer>
        </DialogContent>
        <DialogActions
          primary={{
            label: DONE,
            loading: saving,
            disabled: saving || !canSave,
            onClick: this.onClick,
          }}
          secondary={{
            label: 'Cancel',
            onClick: close,
          }}
        />
      </Dialog>
    );
  }
}

EditMessageModal.propTypes = {
  close: PropTypes.func.isRequired,
  message: types.Message,
  save: PropTypes.func.isRequired,
  saving: PropTypes.bool,
  handleResetScanStatus: PropTypes.func.isRequired,
  editorConfig: PropTypes.shape({
    filesUrl: PropTypes.string,
    apiUrl: PropTypes.string,
  }).isRequired,
};

EditMessageModal.defaultProps = {
  message: undefined,
  saving: false,
};

const wrap = flow(onlyWhenDefined(['message']));

const mapDispatchToProps = (dispatch) => ({
  handleResetScanStatus: () => dispatch(resetAllFileScanStatuses()),
});

export default connect(null, mapDispatchToProps)(wrap(EditMessageModal));
